import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import { AppShell } from './AppShell'
import { RouteError } from './RouteError'
import { AuthGate } from '@/features/auth/AuthGate'
import { Skeleton } from '@/components/ui/primitives'

const LoginPage = lazy(() => import('@/features/auth/LoginPage'))
const DatasetStorePage = lazy(() => import('@/features/dataset-store/DatasetStorePage'))
const ModelStorePage = lazy(() => import('@/features/model-store/ModelStorePage'))
const MetricsStorePage = lazy(() => import('@/features/metrics-store/MetricsStorePage'))
const NewEvaluationPage = lazy(() => import('@/features/evaluation-builder/NewEvaluationPage'))
const RunHistoryPage = lazy(() => import('@/features/run-history/RunHistoryPage'))
const RunDetailPage = lazy(() => import('@/features/run-detail/RunDetailPage'))
const SettingsPage = lazy(() => import('@/features/settings/SettingsPage'))

function RouteFallback() {
  return (
    <div className="space-y-3">
      <Skeleton className="h-8 w-64" />
      <Skeleton className="h-64 w-full" />
    </div>
  )
}

function page(element: React.ReactNode) {
  return <Suspense fallback={<RouteFallback />}>{element}</Suspense>
}

export const router = createBrowserRouter([
  {
    path: '/login',
    element: page(<LoginPage />),
    errorElement: <RouteError />,
  },
  {
    path: '/',
    element: <AuthGate />,
    errorElement: <RouteError />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <Navigate to="/evaluations" replace /> },
          { path: 'library/datasets', element: page(<DatasetStorePage />) },
          { path: 'library/models', element: page(<ModelStorePage />) },
          { path: 'library/metrics', element: page(<MetricsStorePage />) },
          { path: 'evaluations', element: page(<RunHistoryPage />) },
          { path: 'evaluations/new', element: page(<NewEvaluationPage />) },
          { path: 'evaluations/:runId', element: page(<RunDetailPage />) },
          { path: 'settings', element: page(<SettingsPage />) },
          { path: '*', element: <Navigate to="/evaluations" replace /> },
        ],
      },
    ],
  },
])
